import type { SVGProps } from 'react';

const SvgCompliance = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" {...props}>
    <g fill={props.color} data-name="compliance">
      <path d="M28.87 5.71A2.75 2.75 0 0 0 26.12 3h-2.58V.32H22V3h-5.43V.32h-1.5V3H9.61V.32h-1.5V3H5.88a2.75 2.75 0 0 0-2.75 2.71v2.57H.5v1.5h2.63v5.47H.5v1.5h2.63v5.47H.5v1.5h2.63v2.57A2.75 2.75 0 0 0 5.88 29h2.23v2.64h1.5V29h5.46v2.64h1.5V29H22v2.64h1.5V29h2.58a2.75 2.75 0 0 0 2.75-2.75v-2.53h2.67v-1.5h-2.63v-5.47h2.63v-1.5h-2.63V9.78h2.63v-1.5h-2.63Zm-1.5 20.58a1.25 1.25 0 0 1-1.25 1.25H5.88a1.25 1.25 0 0 1-1.25-1.25V5.71a1.25 1.25 0 0 1 1.25-1.25h20.24a1.25 1.25 0 0 1 1.25 1.25Z" />
      <path d="m15.58 16.88-2.49-2.48L12 15.46l3 3a.74.74 0 0 0 .53.22.7.7 0 0 0 .53-.22l8.67-8.63-1.02-1.05Z" />
      <path d="M21.51 14.85A6 6 0 1 1 19 11.2l.85-1.2a7.53 7.53 0 1 0 3.31 6.23 7.8 7.8 0 0 0-.16-1.71Z" />
    </g>
  </svg>
);

export default SvgCompliance;
